module.exports = __webpack_public_path__ + "img/pics_safe-reliable.219b028e.svg";